import { Component } from '@angular/core';

@Component({
    selector: 'app-remove-saved-payment-card',
    templateUrl: './remove-saved-payment-card.component.html',
    styleUrls: ['./remove-saved-payment-card.component.scss'],
    standalone: false
})
export class RemoveSavedPaymentCardComponent {

}
